module.exports = __webpack_public_path__ + "img/violet_007.e32596bf.png";